import { createStore } from "vuex";
import Cases from '@/store/modules/cases'
import Game from '@/store/modules/game'

export default createStore({
    modules: {
        cases: Cases,
        game: Game
    }
});